module.exports = __webpack_public_path__ + "img/langleague.b3c62005.jpg";